import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Component3cards from '../components/component3cards'
import FooterMain from '../components/footer-main'
import './education-cells.css'

const EducationCells = (props) => {
  return (
    <div className="education-cells-container">
      <Helmet>
        <title>
          Образовательные робототехнические комплексы и стенды PLC | Arcobo
        </title>
        <meta
          name="description"
          content="Arcobo разрабатывает образовательные робототехнические комплексы, учебные стенды Siemens PLC и лаборатории для обучения промышленной автоматизации и робототехнике."
        />
        <meta
          property="og:title"
          content="Образовательные робототехнические комплексы и стенды PLC | Arcobo"
        />
        <meta
          property="og:description"
          content="Arcobo разрабатывает образовательные робототехнические комплексы, учебные стенды Siemens PLC и лаборатории для обучения промышленной автоматизации и робототехнике."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Образовательные робототехнические комплексы и стенды PLC | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Arcobo разрабатывает образовательные робототехнические комплексы, учебные стенды Siemens PLC и лаборатории для обучения промышленной автоматизации и робототехнике."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/education-cells"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/education-cells"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"EducationCells","item":"https://arcobo.tech/education-cells"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name16"></HeaderMain>
      <hr className="education-cells-separator1"></hr>
      <Component3cards
        titleAs="h1"
        componentText="Комплексные лабораторные решения для подготовки специалистов в области промышленной робототехники, автоматизации и цифрового производства"
        feature1Title="Интегрированная лаборатория по автоматизации"
        feature2Title="Роботизированная учебная ячейка"
        feature3Title="Учебный стенд PLC Siemens"
        rootClassName="component3cardsroot-class-name3"
        componentTitle="Учебные робототехнические комплексы"
        feature1Title2={
          <Fragment>
            <span className="education-cells-text10">feature1Title</span>
          </Fragment>
        }
        feature2Title2={
          <Fragment>
            <span className="education-cells-text11">
              <span className="H1_extrasmall">
                Роботизированная учебная ячейка
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Title2={
          <Fragment>
            <span className="education-cells-text15">
              <span className="education-cells-text16 H1_extrasmall">
                Учебный стенд PLC Siemens
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        feature1ImageSrc="/1_Solution/1_3_1_educational_robotic_syst/laboratory_1-1500w.webp"
        feature1ImageAlt="Учебная лаборатория робототехники"
        feature2ImageSrc="/1_Solution/1_3_1_educational_robotic_syst/cell_2-400h.webp"
        feature2ImageAlt="Учебная роботизированная ячейка"
        feature3ImageSrc="/1_Solution/1_3_1_educational_robotic_syst/stand_3-400h.webp"
        feature3ImageAlt="Учебный стенд Astorino"
        feature1Description={
          <Fragment>
            <span className="education-cells-text19">
              <span>
                Комплексная учебно-производственная система для изучения
                промышленной робототехники, программирования, машинного зрения,
                PLC и интеграции автоматизированных производственных линий
              </span>
              <br></br>
              <br></br>
              <span className="education-cells-text23">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Промышленный робот Kawasaki RS007L с линейной 7-й осью
              </span>
              <br></br>
              <span className="education-cells-text26">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                PLC Siemens, HMI-панель оператора и промышленная сеть
                Ethernet/IP
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span className="education-cells-text29">•</span>
              <span>
                {' '}
                Комплект сменных захватов, токарный патрон, конвейер и
                технологическая оснастка
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span className="education-cells-text32">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Возможность моделирования полного производственного цикла – от
                загрузки детали до контроля качества
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature2Description1={
          <Fragment>
            <span className="education-cells-text37">
              <span>
                Компактная мобильная учебная ячейка на базе промышленного робота
                Kawasaki RS007L для проведения лабораторных работ, соревнований,
                демонстраций и отработки производственных технологий.
              </span>
              <br></br>
              <br></br>
              <span className="education-cells-text41">• </span>
              <span>
                Полноразмерный промышленный робот Kawasaki RS007L в безопасном
                защитном ограждении
              </span>
              <br></br>
              <span className="education-cells-text44">• </span>
              <span>
                Быстрое развертывание в аудиториях, выставках, чемпионатах и
                демонстрационных залах
              </span>
              <br></br>
              <span className="education-cells-text47">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Отработка реальных производственных технологических процессов и
                программ робота
              </span>
              <br></br>
              <span className="education-cells-text50">• </span>
              <span>
                Подходит для проведения соревнований, демонстрационных экзаменов
                и практических занятий
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Description1={
          <Fragment>
            <span className="education-cells-text53">
              <span>
                Учебный стенд для подготовки студентов вузов в области
                промышленной автоматизации, программирования систем управления и
                цифрового производства.
              </span>
              <br></br>
              <br></br>
              <br></br>
              <span className="education-cells-text58">• </span>
              <span>Программирование PLC Siemens</span>
              <br></br>
              <span className="education-cells-text61">• </span>
              <span>
                Работа с датчиками, приводами и исполнительными механизмами
              </span>
              <br></br>
              <span className="education-cells-text64">•</span>
              <span> Изучение промышленных протоколов связи и HMI</span>
              <br></br>
              <span className="education-cells-text67">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Основа для подготовки инженеров по промышленной автоматизации
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
            </span>
          </Fragment>
        }
      ></Component3cards>
      <hr className="education-cells-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name16"></FooterMain>
    </div>
  )
}

export default EducationCells
